import React, { useEffect } from 'react';
import { Hostnames } from '../constants/author-domains';
import Routes from '../constants/routes';
import authorMaterialIdsService from '../services/authors/authors-material-ids';
import { storageKeys } from './browser-storage/storage-keys';
import isAuthorDomain from './is-author-domain';
import cutWorldFromURL from './url/cut-world-from-url';

const authorDomain = isAuthorDomain() as Hostnames;

const crossDomainGAWrapper = (href: string) => {
    let destinationUrl = href;

    if (window.ga !== undefined && typeof window.ga.getAll === 'function') {
        const trackers = window.ga.getAll();

        if (trackers.length) {
            const linker = new window.gaplugins.Linker(trackers[0]);

            destinationUrl = linker.decorate(href);
        }
    }

    return destinationUrl;
};

const fetchAuthorMaterialIds = () => {
    if (authorDomain) {
        authorMaterialIdsService.get(authorDomain.id).then((materialIds) => {
            // @ts-ignore
            authorDomain.materialIds = materialIds;
        });
    }
};

export const domainLinkCreator = (href: string) => {
    let url = href;

    if (authorDomain && href) {
        if (href.indexOf(`${Routes.AUTHOR_MAIN.prefix}/${authorDomain.id}`) >= 0) {
            // if (url.indexOf(Routes.AUTHOR_DOMAIN_MATERIALS.path) >= 0) {
            //     url = url.substring(url.indexOf(Routes.AUTHOR_DOMAIN_MATERIALS.path));
            // } else if (url.indexOf(Routes.AUTHOR_DOMAIN_BLOG.path) >= 0) {
            //     url = url.substring(url.indexOf(Routes.AUTHOR_DOMAIN_BLOG.path));
            // } else {
            //     url = Routes.HOME.path;
            // }

            const index = url.indexOf('?');

            url = index > -1 ? `/${url.substring(index)}` : '/';
        } else if (href.indexOf(`${Routes.MATERIAL.prefix}/`) >= 0) {
            let authorsMaterialPath = false;

            if (authorDomain.materialIds) {
                authorDomain.materialIds.forEach((materialId) => {
                    if (href.indexOf(`${Routes.MATERIAL.prefix}/${materialId}`) >= 0) {
                        authorsMaterialPath = true;
                    }
                });
            }

            if (!authorsMaterialPath) {
                url = `${process.env.REACT_APP_FRONT_URL}${href}`;
            } else {
                url = cutWorldFromURL(href, authorDomain?.world);
            }
        } else if (href.indexOf(Routes.WARENKORB.path) >= 0) {
            const token = window.storage.getItem(storageKeys.cart.cartToken) || '';

            url = `${process.env.REACT_APP_FRONT_URL}${Routes.WARENKORB.path}?c_t=${token}`;
            url = crossDomainGAWrapper(url);
        } else {
            url = `${process.env.REACT_APP_FRONT_URL}${href}`;
            url = crossDomainGAWrapper(url);
        }
    }

    return url;
};

type DomainManagerProps = {
    domainComponent: React.JSX.Element;
    originalComponent: React.ReactNode;
};

export const DomainManager: React.FC<DomainManagerProps> = ({ domainComponent, originalComponent }) => {
    const path = window.location.pathname;

    useEffect(() => {
        fetchAuthorMaterialIds();
    }, []);

    if (authorDomain) {
        if (
            path === '/' ||
            path === Routes.AUTHOR_DOMAIN_MATERIALS.path ||
            path === Routes.AUTHOR_DOMAIN_BLOG.path ||
            path.indexOf(Routes.AUTHOR_DOMAIN_MATERIAL_PAGE.prefix) === 0
        ) {
            return React.cloneElement(domainComponent, { domainId: authorDomain.id });
        }
    }

    if (!originalComponent) {
        window.locationReload('/');

        return <></>;
    }

    return <>{originalComponent}</>;
};
